import styled from "styled-components";

export const ActionsManagementContainer = styled.div`
  margin: 20px 0;
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 610px) {
    padding: 10px;
    height: auto;
  }
`;
export const ManagementDiv = styled.div`
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const AlignContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 610px) {
    width: 100%;
    flex-direction: column;
    justify-content: space-around;
  }
`;
export const DownloadButton = styled.button`
  padding: 0 8px;
  height: 38px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #34a853;
  outline: none;
  background: transparent;
  cursor: pointer;
  gap: 8px;
`;
export const FileImg = styled.img`
  width: 24px;
`;
export const DownloadText = styled.p`
  color: #34a853;
  font-size: 14px;
  font-weight: 600;
`;
